export const DISABLE_DEV_ANALYTICS = false

export const AnalyticsDisabled = (): boolean => {
  if (__DEV__) {
    return DISABLE_DEV_ANALYTICS
  }
  return false
}
